<template>
	<div>
		<div v-show="initpage" class="defaultpage">
			<!-- <Icon class="spinner" color="#165DFF" size=18 type="ios-loading" />涉税风险检测功能加载中... -->
			<FXJC class="fxjc" @risk-detection="checkAndGo" />
		</div>
		<!-- <div v-if="showriskpage" class="container">
		    <iframe :src="riskdetectionurl" frameborder="0" @load="onIframeLoad"></iframe>
	  	</div> -->
	</div>
</template>
<script>
import store from "../../store"
import eventBus from "../../components/common/event_bus.js"
import fxjc from "../home/fxjc.vue"
	export default{
		name:"tax_risk_detection",
		inject: ["setRiskDetectionIndex"],
		data(){
			return{
				loadingmask:true,
				loadingtext:true,
				initpage:true,
				showriskpage:false,
				riskdetectionurl:this.$baseConfig.riskDetectionUrl,
			}
		},
		created(){
			console.log("tax_risk_detection created==>")
			// if(this.checkUserLogin()){
			// 	this.loadingRiskDetectionPage()
			// }else{
			// 	console.log("emit user-login")
			// 	setTimeout(()=>{
			// 		eventBus.$emit("user-login", "true", '0')
			// 	},1000)
				
			// }
			this.setRiskDetectionIndex()
		},
		mounted(){
			//通过用户登录拉起风险检测功能
			eventBus.$on('access_tax_risk_detection', () => {
				console.log("on access_tax_risk_detection==>")
				this.loadingRiskDetectionPage()
        	})
		},
		components:{
			"FXJC":fxjc,
		},
		methods:{
			onIframeLoad() {
				console.log('Iframe content has been fully loaded.');
				this.initpage=false
				// this.loadingmask=false
				// this.loadingtext=false
				// this.setupMessageListener();
			},
			checkAndGo(){
				console.log("check login and go risk detection")
				if(this.checkUserLogin()){
					console.log(store.state.user.mobileNum!='')
					if(store.state.user.mobileNum!==''){
						this.loadingRiskDetectionPage()
					}else{
						this.checkUserMobile()
					}
					//this.loadingRiskDetectionPage()
				}else{
					setTimeout(()=>{
						eventBus.$emit("user-login", "true", '6')//检测登录
					},0)
				}
			},
			checkUserMobile() {
	            this.$Modal.confirm({
	                title: '提示',
	                content: '<p>系统检测到您尚未绑定手机号码(请绑定后使用风险检测功能)，是否绑定手机号码？</p>',
	                cancelText: "否",
	                okText: '是',
	                onOk: () => {
	                    //this.weiXinRegAndLogin(po)
	                    // this.weixinRegV2(po)
	                    eventBus.$emit("user-bind-mobile")
	                },
	                onCancel: () => {
	                    return
	                }
	            });
        	},
			loadingRiskDetectionPage(){
				var load_url = this.riskdetectionurl+store.state.user.token
				console.log("loadding page:"+load_url)
				window.open(load_url, '_blank')
				// this.showriskpage=true
			},
			checkUserLogin() {
	            // console.log(store.state.user.userId)
	            if (store.state.user.userId === undefined || store.state.user.userId === "") {
	                return false
	            } else {
	                return true
	            }
        	},
		},
		beforeDestroy(){
			eventBus.$off('access_tax_risk_detection')
		},
		watch: {
		}
	}
</script>
<style lang="less" scoped>
.defaultpage{
	width: 100%; /* 父容器宽度 */
  	// height: 80vh; /* 父容器高度，这里设置为视口高度 */
  	display: flex; /* 使用flex布局 */
  	justify-content: center; /* 水平居中 */
  	align-items: center; /* 垂直居中 */
  	background-color: #E8F3FF;
  	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color:#2b85e4;
	.spinner {
	  animation: spin 1s linear infinite;
	}
	@keyframes spin {
	  to {
	    transform: rotate(360deg);
	  }
	}
	.fxjc{
		padding:0px;
		margin:0px;
	}
}
/* 设置父容器的样式 */
.container {
  width: 100%; /* 父容器宽度 */
  height: 89.40vh; /* 父容器高度，这里设置为视口高度 */
  // border: 1px solid #ccc; /* 可选：添加边框以便观察 */
  display: flex; /* 使用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

/* 设置iframe的样式 */
.container iframe {
  width: 100%; /* iframe宽度占满父容器 */
  height: 100%; /* iframe高度占满父容器 */
  border: none; /* 去掉iframe的边框 */
}

/*spin style*/
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
}


</style>